import Checkbox, { CHECKBOX_STATE } from 'Components/Atoms/Checkbox/Checkbox';
import HighlightedText from 'Components/Atoms/HighlightedText/HighlightedText';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import Loader, { LOADER_SIZE } from 'Components/Atoms/Loader/Loader';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import TagGroup from 'Components/Molecules/TagGroup/TagGroup';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { getAccessTokenFromLocal, getEntityRouteByInternalDataset, InternalDatasets, useOuterClick } from 'Services/helpers';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { fetchBusinessDataset } from 'Store/Business/Actions';
import { getBusinessDataset } from 'Store/Business/Selectors';
import { fetchBusinessUnitDataset } from 'Store/BusinessUnit/Actions';
import { getBusinessUnitDataset, getBusinessUnitDatasetKeys } from 'Store/BusinessUnit/Selectors';
import { fetchCandidateDataset } from 'Store/Candidate/Actions';
import { getCandidateDataset } from 'Store/Candidate/Selectors';
import { fetchContactDataset } from 'Store/Contact/Actions';
import { getContactDataset, getContactDatasetKeys } from 'Store/Contact/Selectors';
import { fetchAllDatasets } from 'Store/FieldManagement/Actions';
import {getAllDatasets, getDatasetByIds, getDatasetLabels, getDatasetPathById} from 'Store/FieldManagement/Selectors';
import { StoreState } from 'Store/Reducers';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';
import { fetchUsersDataset } from 'Store/User/Actions';
import { getUserDataset, getUserDatasetKeys } from 'Store/User/Selectors';
import { fetchVacancyDataset } from 'Store/Vacancy/Actions';
import { getVacancyDataset } from 'Store/Vacancy/Selectors';
import styles from './MultiSelectorField.module.sass';
import MultiSelectorFieldDropdownItem from './MultiSelectorFieldDropdownItem';

const MultiSelectorField = ({isEdit, onChange, value: rawValue = [], fieldProperties, ...props }: MultiSelectorProps) => {
    const isEmpty = !rawValue || !Array.isArray(rawValue) || rawValue?.length == 0;
    const [searchTimer, setSearchTimer] = useState<any>(null);
    const [data, setData] = useState<any>({
        key: fieldProperties?.dataset?.dataset?.length > 0 ? fieldProperties?.dataset?.dataset[0] : null,
        
        original: props.datasets || [],
        originalKeys: [],
        originalFilterValue: [],

        relationKeys: [],
        relationFilterValue: [],
        relationInput: [],
        relations: [],
        
        filterValue: [],
        filtered: [],
        
        page: 0,
        pageSize: 50,
        totalPages: 0,
        searchQuery: '',
    });
    const [state, setState] = useState<any>({
        isFocused: false,
        isLoading: false,
        isFiltering: false,
        isPaginated: true,
        isMultiLevel: false,
    });
    const debounceDelay = 350;
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => {
        setState({...state, isFocused: false});
        setData({...data, searchQuery: ''});
    });

    const resetDatasets = () => {
        if (state.isMultiLevel) {
            const filtered = data?.filterValue.map((item: any) => item?.path || [item?.id]);
            setData((data) => ({
                ...data,
                relationKeys: [],
                relationFilterValue: [],
                relationInput: [],
                relations: [],
                filterValue: data.originalFilterValue,
                filtered: filterDataset(filtered)
            }));
            
            return;
        }

        setData((data) =>({
            ...data,
            relationKeys: [],
            relationFilterValue: [],
            relationInput: [],
            relations: [],
            filterValue: data.originalFilterValue,
            filtered: getFilterPage()
        }));
    }

    const handleFocusClick = () => {
        if (fieldProperties.isDisabled) return;

        setState({...state, isFocused: true});
        setTimeout(() => inputRef?.current?.focus(), 100);

        if (data.page == 0) {
            prepareDatasets();
            
            return;
        }

        setData({...data, page: 1});
    }

    const fetchDatasets = async () => {
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                await props.fetchCandidateDataset();
                break;
            case InternalDatasets.VACANCIES:
                await props.fetchVacancyDataset();
                break;
            case InternalDatasets.BUSINESS:
                await props.fetchBusinessDataset();
                break;
            case InternalDatasets.BUSINESS_UNITS:
                await props.fetchBusinessUnitDataset();
                break;
            case InternalDatasets.CONTACT:
                await props.fetchContactDataset();
                break;
            case InternalDatasets.USERS:
                await props.fetchUsersDataset();
                break;
            default:
                await props.fetchAllDatasets();
                break;
        }
    }

    const prepareDatasets = () => {  
        let dataset = {};
        let datasetKeys: any[] = [];
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                dataset = props.candidateDataset;
                break;
            case InternalDatasets.VACANCIES:
                dataset = props.vacancyDataset;
                break;
            case InternalDatasets.BUSINESS:
                dataset = props.businessDataset;
                break;
            case InternalDatasets.BUSINESS_UNITS:
                dataset = props.businessUnitDataset;
                datasetKeys = props.businessUnitDatasetKeys;
                break;
            case InternalDatasets.CONTACT:
                dataset = props.contactDataset;
                datasetKeys = props.contactDatasetKeys;
                break;
            case InternalDatasets.USERS:
                dataset = props.userDataset;
                datasetKeys = props.userDatasetKeys;
                break;
            default:
                if (data.key) {
                    dataset = props.datasetById[data.key];
                    datasetKeys = props.datasetById[data.key];
                } else {
                    dataset = props.datasets;
                    datasetKeys = props.datasets;
                }
        }

        let datasetFilterValue: any = [];
        const pushDatasetFilter = (id, value, path: any = undefined) => {
            datasetFilterValue.push({
                ...(path && { path: path } ),
                id: id,
                value: value
            });
        }

        const loop = (datasetKeys, path: any[] = []) => {
            datasetKeys.map((item: any) => {
                const newPath = [...path, item.value];
                if (item.children) { loop(item.children, newPath) }

                pushDatasetFilter(item.value, item.title.toLowerCase(), newPath);
            });
        }

        let isMultiLevel = state.isMultiLevel;
        for (const key of Object.keys(dataset)) {
            if (data.key >= 0) {
                const item = dataset[key];
                if (item.children) {
                    if (state.isPaginated) {
                        isMultiLevel = true;
                    }

                    loop(item.children, [item.value]);
                    continue;
                }

                pushDatasetFilter(item.value, item.title.toLowerCase());
                
                continue;
            }

            if (data.key == InternalDatasets.USERS) {
                pushDatasetFilter(key, dataset[key].name + ' ' + dataset[key].email);

                continue;
            }
            
            pushDatasetFilter(key, dataset[key].toLowerCase());
        }

        const a = {
            ...data,
            original: dataset,
            originalKeys: datasetKeys,
            originalFilterValue: datasetFilterValue,
            filterValue: datasetFilterValue,
            filtered: getFilterPage(1, isMultiLevel ? datasetFilterValue : datasetKeys, isMultiLevel),
            page: 1,
            totalPages: Math.round(datasetKeys.length / data.pageSize)
        };

        if (isMultiLevel && rawValue[0]) {
            a.activePaths = datasetFilterValue.find((item: any) => item.id == rawValue[0])?.path;
        }

        setData(a);
        setState({
            ...state,
            isFocused: true,
            isMultiLevel: isMultiLevel,
            isPaginated: !isMultiLevel
        });
    }

    const filterDataset = (filtered: any, values: any[] | undefined = undefined) => {
        let filteredItems: any = [];
        let rootMap: any = [];
        let hashMap: any = {};
        let hashMapCount: any = {};
        filtered.map((item: any) => {
            item.forEach((a: any, index: any) => {
                if (!rootMap.includes(a) && index == 0) {
                    rootMap.push(a);
                }

                const nextItem = item[index+1];
                if (!hashMap[a] && nextItem) {
                    hashMap[a] = [];
                    hashMapCount[a] = {
                        total: 0,
                        selected: 0
                    }
                }

                if (nextItem && !hashMap[a].includes(nextItem)) {
                    hashMap[a].push(nextItem);
                }
            });
        });

        const loop = (hash: any, parentKey: any) => {
            let output: any = [];
            hash.forEach((key) => {
                if (!hashMap[key]) {
                    hashMapCount[parentKey] = {
                        ...hashMapCount[parentKey],
                        total: hashMapCount[parentKey]?.total + 1,
                        selected: (values || rawValue).includes(key) ? hashMapCount[parentKey]?.selected + 1 : hashMapCount[parentKey]?.selected
                    }

                    return output.push({ id: key });
                }
                
                output.push({
                    id: key,
                    children: loop(hashMap[key], key)
                });
            });

            return output;
        };

        rootMap.forEach((key) => {
            if (!hashMap[key]) {
                return filteredItems.push({ id: key });
            }

            return filteredItems.push({
                id: key,
                children: loop(hashMap[key], key)
            });
        });

        const countTotal = (item, totalKey, total = 0) => {
            if (hashMapCount[item.id]) {
                total += hashMapCount[item.id][totalKey]
            }

            if (item.children) {
                item.children.forEach((item) => {
                    total += countTotal(item, totalKey)
                })
            }

            return total;
        }

        const countFilteredItems = (array: any) => {
            return array.map((item: any) => {
                let s = {...item};
                if (item.children) {
                    s.children = countFilteredItems(item.children);
                    s.total = countTotal(item, 'total');
                    s.selected = countTotal(item, 'selected');
                }

                return {...s};
            });
        }

        return countFilteredItems(filteredItems);
    }

    const getFilterPage = (page: number = 1, datasetKeys: any = null, isMultiLevel = false) => {
        if ((isMultiLevel || state.isMultiLevel)) {
            const filtered = (datasetKeys || data.filterValue)
                .map((item: any) => item?.path || [item?.id]);

            return filterDataset(filtered);
        }

        return (datasetKeys || data.originalKeys)
            .slice(0, page * data.pageSize)
            .map((item) => ({ id: item?.value || item }));
    };

    const labels = (id, labelForList = false) => {
        let output = {};
        switch (data.key) {
            case InternalDatasets.CANDIDATES:
                output = {
                    label: props.candidateDataset?.[id] || '',
                    url: EntityHelper.getEntityRoute(data.key, id)
                }
                break;
            case InternalDatasets.VACANCIES:
                output = {
                    label: props.vacancyDataset?.[id] || '',
                    url: EntityHelper.getEntityRoute(data.key, id)
                }
                break;
            case InternalDatasets.BUSINESS:
                output = {
                    label: props.businessDataset?.[id] || '',
                    url: EntityHelper.getEntityRoute(data.key, id)
                }
                break;
            case InternalDatasets.BUSINESS_UNITS:
                output = {
                    label: props.businessUnitDataset?.[id] || '',
                    url: EntityHelper.getEntityRoute(data.key, id)
                }
                break;
            case InternalDatasets.CONTACT:
                output = {
                    label: props.contactDataset?.[id] || '',
                    url: EntityHelper.getEntityRoute(data.key, id)
                }
                break;
            case InternalDatasets.USERS:
                if (labelForList) {
                    output = { label: `${props.userDataset[id]?.name} (${props.userDataset[id]?.email})`}
                } else {
                    output = { label: props.userDataset[id]?.name || ''};
                }
                break;
            default:
                if (!props.datasetPathById) {
                    output = {
                        label: 'Laden...',
                        path: 'Laden...'
                    };

                    break;
                }

                let label, path = '';
                const datasetPath = props.datasetPathById[id];

                if (Array.isArray(datasetPath)) {
                    datasetPath.forEach((item: any, index: number, array: any[]) => {
                        if (array.length >= 3 && index == 0) {
                            label = '../' + props.datasetLabels[id];
                        } else if (array.length < 3) {
                            label = props.datasetLabels[id];
                        } else {
                            path += ((index >= 2) ? '/' : '') + props.datasetLabels[item];
                        }
                    });
                }

                output = { label, path };
        }
        
        return { ...output, value: id };
    }

    const getLabel = (id) => labels(id);
    const getDatasetLabel = (id) => labels(id, true);

    const handleClick = (a: any) => {
        if (a == null) {
            onChange([]);

            return;
        }

        let values: any = Array.isArray(rawValue) ? [...rawValue] : [];

        if (props.datasetById[a]) {
            let output: any = [];
            const loop = (children: any) => {
                children.map((item: any) => {
                    if (item.children) {
                        loop(item.children);
                    }

                    if (fieldProperties?.inRelation?.length > 0) {
                        if (data.relations.includes(item.value)) {
                            output.push(item.value);
                        }

                        return;
                    }

                    const searchQuery = data.searchQuery.trim().toLowerCase();
                    if (searchQuery) {
                        if (item.title.trim().toLowerCase().includes(searchQuery)) {
                            output.push(item.value);
                        }

                        return;
                    }
                    
                    output.push(item.value);
                });
            };

            loop(props.datasetById[a]);

            let add = true;
            for (let i = 0; i <= output.length; i++) {
                if (!add) break;
                if (values.includes(output[i])) {
                    add = false;
                }
            }

            if (!add) {
                values = values.filter((item: any) => !output.includes(item));
            } else {
                values = [...values, ...output];
            }
        } else {
            for (const item of a) {
                if (values.includes(item)) {
                    const index = values.indexOf(item);
                    if (index > -1) {
                        values.splice(index, 1);
                    }
                } else {
                    values.push(item);
                }
            }
        }

        if (state.isMultiLevel) {
            const searchQuery = data.searchQuery.trim().toLowerCase();
            const filtered = data.filterValue
                .filter((item: any) => item.value.includes(searchQuery))
                .map((item: any) => item?.path || [item?.id]);
            setData({...data, filtered: filterDataset(filtered, values)});
        }

        onChange(values);
    }

    const loadMoreRef: any = useRef();
    const handleScroll = (e) => {
        if (!state.isPaginated) return;
        if (data.page >= data.totalPages) return;

        const bottomThreshold = e.currentTarget.scrollHeight - e.target.scrollTop <= e.target.clientHeight * 3;
        if (bottomThreshold) { 
            const nextPage = data.page + 1;

            setData({
                ...data,
                filtered: getFilterPage(nextPage),
                page: nextPage
            });
        }
    }

    // useEffect(() => {
    //     console.log('SEARCH QUERY: ', data.searchQuery);
    //     if (!data?.originalFilterValue) return; 
    //     if (searchTimer) {
    //         clearTimeout(searchTimer);
    //         setSearchTimer(null);
    //     }
    //
    //     if (data.searchQuery == '') {
    //         clearTimeout(searchTimer);
    //         setSearchTimer(null);
    //
    //         setState((state) => ({
    //             ...state,
    //             isFiltering: false
    //         }));
    //
    //         const hasRelation = fieldProperties?.inRelation?.length > 0;
    //         if (hasRelation) {
    //             const relations = fieldProperties?.inRelation;
    //             const hasRelationValueChanged = relations?.length != data.relationInput.length || !data.relationInput.every((val, idx) => val == relations[idx]);
    //             if (hasRelationValueChanged) {
    //                 setState({
    //                     ...state,
    //                     isPaginated: false,
    //                     isLoading: true
    //                 });    
    //                 fetchRelations();
    //
    //                 return;
    //             }
    //
    //             const relationFiltered = filterDataset(data.relationFilterValue.map((item: any) => item?.path || [item?.id]));
    //             setData({
    //                 ...data,
    //                 filterValue: data.relationFilterValue,
    //                 filtered: relationFiltered
    //             });
    //
    //             return;
    //         }
    //
    //         resetDatasets();
    //
    //         return;
    //     }
    //
    //     setState({...state, isFiltering: true});
    //     setSearchTimer(
    //         setTimeout(() => {
    //             setState({...state, isFiltering: false});
    //
    //             const searchQuery = data.searchQuery.trim().toLowerCase();
    //             if (state.isMultiLevel) {
    //                 const filtered = data?.filterValue
    //                     .filter((item: any) => item.value.includes(searchQuery))
    //                     .map((item: any) => item?.path || [item?.id]);
    //
    //                 setData({...data, filtered: filterDataset(filtered)});
    //
    //                 return;
    //             }
    //
    //             setData({...data, filtered: data?.filterValue
    //                 .filter((item: any) => item.value.includes(searchQuery))
    //                 .map((item: any) => ({ id: item.id }))});
    //         }, debounceDelay)
    //     );
    // }, [data.searchQuery]);

    const handleSearchQuery = (e) => {
        const rawSearchQuery = e.target.value;
        console.log('RAW SEARCH QUERY: ', rawSearchQuery);
        setData((data) => ({
            ...data,
            searchQuery: rawSearchQuery
        }));

        if (searchTimer) {
            clearTimeout(searchTimer);
            setSearchTimer(null);
        }

        if (rawSearchQuery == '') {
            setState((state) => ({
                ...state,
                isFiltering: false
            }));

            const hasRelation = fieldProperties?.inRelation?.length > 0;
            if (hasRelation) {
                const relations = fieldProperties?.inRelation;
                const hasRelationValueChanged = relations?.length != data.relationInput.length || !data.relationInput.every((val, idx) => val == relations[idx]);
                if (hasRelationValueChanged) {
                    setState((state) => ({
                        ...state,
                        isPaginated: false,
                        isLoading: true
                    }));
                    fetchRelations();

                    return;
                }

                const relationFiltered = filterDataset(data.relationFilterValue.map((item: any) => item?.path || [item?.id]));
                setData((data) => ({
                    ...data,
                    filterValue: data.relationFilterValue,
                    filtered: relationFiltered
                }));

                return;
            }

            resetDatasets();

            return;
        }

        setState((state) => ({
            ...state,
            isFiltering: true
        }));
        setSearchTimer(
            setTimeout(() => {
                setState((state) => ({
                    ...state,
                    isFiltering: false
                }));

                const searchQuery = rawSearchQuery.trim().toLowerCase();
                if (state.isMultiLevel) {
                    const filtered = data?.filterValue
                        .filter((item: any) => item.value.includes(searchQuery))
                        .map((item: any) => item?.path || [item?.id]);

                    setData((data) => ({
                        ...data,
                        filtered: filterDataset(filtered)
                    }));

                    return;
                }

                setData((data) => ({
                    ...data,
                    filtered: data?.filterValue
                        .filter((item: any) => item.value.includes(searchQuery))
                        .map((item: any) => ({ id: item.id }))
                }));
            }, debounceDelay)
        );
    };

    const fetchRelations = async () => {
        const accessToken = getAccessTokenFromLocal();

        const preparedRelationValues = fieldProperties?.inRelation.join(',');
        fetch(`${API_URL}/api/field-management/relations/${preparedRelationValues}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        )
            .then(r => r.json())
            .then((response: any) => {
                const relationValues = response?.data;
                const relationFilterValue = data.originalFilterValue.filter((item: any) => relationValues.includes(item.id?.toString()));
                if (relationFilterValue.length <= 0) {
                    setData({
                        ...data,
                        relationKeys: [],
                        relationFilterValue: [],
                        relationInput: [],
                        relations: [],
                        filterValue: data.originalFilterValue,
                        filtered: getFilterPage(1, state.isMultiLevel ? state.originalFilterValue : state.originalKeys, state.isMultiLevel)
                    });
                    setState({
                        ...state,
                        isPaginated: true,
                        isLoading: false
                    });
                    
                    return;
                }
                
                const relationFiltered = filterDataset(relationFilterValue.map((item: any) => item?.path || [item?.id]));

                setData({
                    ...data,
                    relationFilterValue: relationFilterValue,
                    relations: response?.data,
                    relationInput: fieldProperties?.inRelation, 
                    filterValue: relationFilterValue,
                    filtered: relationFiltered
                });
            });
    }

    useEffect(() => {
        setState({...state, isLoading: false});
    }, [data.filterValue]);

    const resetRelationDataset = () => {
        setData({
            ...data,
            relationKeys: [],
            relationFilterValue: [],
            relationInput: [],
            relations: [],
            filterValue: data.originalFilterValue,
            filtered: getFilterPage(1, state.isMultiLevel ? data.originalFilterValue : data.originalKeys, state.isMultiLevel)
        });
    }

    useEffect(() => {
        if (!state.isFocused) return;
        const hasRelation = fieldProperties?.inRelation?.length > 0;
        if (hasRelation) {
            const relations = fieldProperties?.inRelation;
            const hasRelationValueChanged = relations?.length != data.relationInput.length || !data.relationInput.every((val, idx) => val == relations[idx]);
            if (hasRelationValueChanged) {
                setState({
                    ...state,
                    isPaginated: false,
                    isLoading: true
                });    
                fetchRelations();

                return;
            }

            const relationFiltered = filterDataset(data.relationFilterValue.map((item: any) => item?.path || [item?.id]));
            setData({
                ...data,
                filterValue: data.relationFilterValue,
                filtered: relationFiltered
            });

            return;
        }

        resetRelationDataset();
    }, [state.isFocused]);

    useEffect(() => {
        fetchDatasets();
    }, []);

    if (!isEdit) {
        if (isEmpty) {
            
            return <NoValue />;
        }
        
        return <TagGroup
            collapse='medium'
            alignRight={!fieldProperties.alignLeft}
            isCollapsed={fieldProperties.isInline}
        >
            {
                rawValue?.map((id: any) => {
                    const item: any = getLabel(id);
                    
                    return <Tag key={id} url={item?.url || undefined} tooltip={item?.path}>
                        { item?.label }
                    </Tag>;
                })
            }
        </TagGroup>
    }

    return <div className={`${styles['multiselector']} ${state.isFocused ? styles['multiselector--active'] : ''}  ${fieldProperties.isDisabled ? styles['multiselector--disabled'] : ''}`} ref={innerRef}>
        <div className={styles['multiselector__content']} onClick={handleFocusClick}>
            { !isEmpty && <TagGroup collapse='medium'>
                {
                    rawValue.map((id: any) => {
                        const item: any = getLabel(id);
                        
                        return <Tag key={id} onDelete={() => handleClick([id])}>
                            { item?.label }
                        </Tag>;
                    })
                }
            </TagGroup> }
            { (isEmpty && !state.isFocused) && <input placeholder={'Selecteer een waarde...'} style={{pointerEvents: 'none'}}/> }
            {
                state.isFocused && <input
                    placeholder={'Typ hier om te filteren...'}
                    value={data.searchQuery}
                    onChange={handleSearchQuery}
                    ref={inputRef}
                    style={{marginTop: isEmpty ? '0px' : '6px'}}
                />
            }
        </div>
        {
            rawValue?.length > 0 &&
            <div className={styles['multiselector__icon']} onClick={() => handleClick(null)}>
                <Icon type={ICONS.CLOSE} size={'xsmall'} isCircled />
            </div>
        }
        <div className={styles['multiselector__icon']} onClick={handleFocusClick}>
            <Icon type={ICONS.CHEVRON_DOWN} size={'small'}/>
        </div>
        
        { state.isFocused && <div className={styles['multiselector__dropdown']} onScroll={handleScroll}>
            {
                !state.isLoading &&
                !state.isFiltering &&
                data?.filtered?.map((item: any, index: any) => {
                    if (data.key >= 0) {
                        return <MultiSelectorFieldDropdownItem
                            key={item.id}
                            item={item}
                            labels={props.datasetLabels}
                            activeValues={rawValue || []}
                            searchQuery={data.searchQuery}
                            onClick={(v) => handleClick(v)}
                        />
                    }

                    const { label }: any = getDatasetLabel(item.id);

                    return <div className={`${styles['dropdown__item']}`} key={item.id} ref={data.filtered.length-1 == index ? loadMoreRef : undefined}>
                        <Checkbox
                            label={<HighlightedText highlight={data.searchQuery}>{label}</HighlightedText>}
                            onClick={() => handleClick([item.id])}
                            state={rawValue?.includes(item.id) ? CHECKBOX_STATE.ACTIVE : CHECKBOX_STATE.INACTIVE}
                        />
                    </div>;
                })
            }
            { data?.filtered?.length == 0 && <div className={`${styles['dropdown__item']}`}>Geen resultaten gevonden...</div> }
            { (state.isFiltering ||
                state.isLoading) &&
                <Loader size={LOADER_SIZE.MEDIUM} /> }
        </div> }
    </div>
}
interface Props {
    isEdit: boolean,
    onChange: (value: any) => any,
    value: any[],
    fieldProperties: {
        isInline: boolean | undefined,
        alignLeft: boolean | undefined,
        isDisabled: boolean | undefined,
        inRelation: any[],
        dataset: {
            dataset: string[],
            value: string[]
        }
    }
}

const mapState = (state: StoreState) => ({
    datasets: getAllDatasets(state),
    datasetLabels: getDatasetLabels(state),
    datasetById: getDatasetByIds(state),
    datasetPathById: getDatasetPathById(state),
    candidateDataset: getCandidateDataset(state),
    vacancyDataset: getVacancyDataset(state),
    contactDataset: getContactDataset(state),
    contactDatasetKeys: getContactDatasetKeys(state),
    businessDataset: getBusinessDataset(state),
    businessUnitDataset: getBusinessUnitDataset(state),
    businessUnitDatasetKeys: getBusinessUnitDatasetKeys(state),
    userDataset: getUserDataset(state),
    userDatasetKeys: getUserDatasetKeys(state)
});

const mapDispatch = {
    fetchAllDatasets,
    fetchCandidateDataset,
    fetchVacancyDataset,
    fetchContactDataset,
    fetchBusinessDataset,
    fetchBusinessUnitDataset,
    fetchUsersDataset
};

type MultiSelectorProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(MultiSelectorField);